template
<template>
	<sa-page-layout :btnRefreshVisible="true" :btnRouterBackVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading">
		<template #toolbar>
			<b-button variant="primary btn-toolbar sa-margin-right float-sm-right" size="sm" @click="onScaricaCsv"> <font-awesome-icon icon="file-csv" />Download Csv</b-button>
		</template>
		<template slot="table-body">
			<div class="sa-list-component">
				<div class="sa-list-component-header">
					<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
						<b-col lg="3">
							<p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
						</b-col>
						<b-col lg="9">
							<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
						</b-col>
					</b-row>
				</div>
				<div class="sa-list-component-body">
					<div class="b-table-sticky-header" v-if="items.length > 0">
						<b-table sticky-header ref="table" show-empty stacked="lg" striped hover :items="items" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table"> </b-table>
					</div>
					<div class="b-table-sticky-header" v-else>No Elements</div>
				</div>
				<div class="sa-list-component-footer">
					<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
						<b-col lg="3">
							<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
						</b-col>
						<b-col lg="9">
							<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
						</b-col>
					</b-row>
				</div>
			</div>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import moment from "moment";
export default {
	components: { SaPageLayout },
	mixins: [UtilityMixin],
	data() {
		return {
			btnNewVisible: true,
			pathResource: "/dataanalysisdatabaseinfo/eseguigraphicquery/",
			showModalLoading: false,
			filtro: {},
			listKey: 0,
			//rows: 0,
			perPage: 100,
			records: [],
			currentPage: 1,
			id: null,
			items: [],
		};
	},
	mounted() {
		let me = this;
		if (!this.$route.params.id) {
			this.$route.back();
		}
		this.id = this.$route.params.id;
		me.loadData();
	},
	computed: {
		rows() {
			return this.items.length;
		},
	},
	methods: {
		loadData() {
			let me = this;
			me.showModalLoading = true;
			//me.$refs.DataAnalysisDashboardListComponent.loadData();
			me.filtro.page = me.currentPage;
			me.filtro.forPage = me.perPage;
			UtilityMixin.methods.loadDataResources(me.pathResource + me.id, me.filtro, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			//let me = this;
			this.items = response.data.data;
			// me.rows = response.data.data.length;
			// let i = (me.currentPage - 1) * me.perPage;
			// let f = i + me.perPage;

			for (let item of this.items) {
				Object.keys(item).forEach((e) => {
					if (e.toLowerCase().includes("data")) {
						item[e] = moment(item[e]).format("DD/MM/YYYY hh:mm");
					}
				});
			}
			// me.items = items.splice(i, f);
			this.showModalLoading = false;
			// me.$bvToast.toast(`OK`, {
			// 	title: "Caricamento avvenuto con successo",
			// 	variant: "success",
			// 	solid: true,
			// });
		},
		loadDataError(err) {
			let me = this;
			me.showModalLoading = false;
			me.$bvToast.toast(`${err.response.data != null ? err.response.data.messaggio : "Errore durante il caricamento"}""`, {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
		},

		onRefresh() {
			let me = this;
			me.loadData();
		},
		onScaricaCsv() {
			var data = [];
			// console.log(this.$refs.cmpPivotData);
			// console.log(this.items);
			let csvHeader = [];
			if (this.items.length > 0) {
				console.log(Object.keys(this.items[0]));
				csvHeader = Object.keys(this.items[0]);
				data.push(csvHeader);
			}
			this.items.forEach((item) => {
				let row = [];
				csvHeader.forEach((key) => {
					row.push(item[key]);
				});
				data.push(row);
			});
			// console.log(csvHeader);
			// console.log(data);
			let dataString = "";

			// Building the CSV from the Data two-dimensional array
			// Each column is separated by ";" and new line "\n" for next row
			var csvContent = "";
			data.forEach(function (infoArray, index) {
				dataString = infoArray.join(";");
				csvContent += index < data.length ? dataString + "\n" : dataString;
			});

			// The download function takes a CSV string, the filename and mimeType as parameters
			// Scroll/look down at the bottom of this snippet to see how download is called
			var download = function (content, fileName, mimeType) {
				var a = document.createElement("a");
				mimeType = mimeType || "application/octet-stream";

				if (navigator.msSaveBlob) {
					// IE10
					navigator.msSaveBlob(
						new Blob([content], {
							type: mimeType,
						}),
						fileName
					);
				} else if (URL && "download" in a) {
					//html5 A[download]
					a.href = URL.createObjectURL(
						new Blob([content], {
							type: mimeType,
						})
					);
					a.setAttribute("download", fileName);
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				} else {
					location.href = "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
				}
			};

			download(csvContent, "dowload.csv", "text/csv;encoding:utf-8");
		},
	},

	// watch: {
	// 	currentPage: function () {
	// 		let me = this;
	// 		me.loadData();
	// 	},
	// },
};
</script>

<style></style>
